import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Input
} from '@angular/core';


import {ActionService} from "@/services/action.service";


import {Logger} from '@/util/logger';

import {ActivatedRoute, Router} from '@angular/router';

import {ProjectService} from "@/services/project.service";
import {IOrganizationRow} from "@/screens/administration/i.organization.row";

@Component({
  standalone: false,
  selector:    'organization-list-component',
  template: `<div class="project-list-wrapper">

    <ul>
      <li *ngFor="let org of organizations">

        <!-- project logo -->

        <span class="project-list-row-cell" style="min-width: 140px;">

          <a class="project-list-row-link" routerLink="/organization/{{org.key}}"><img src="{{org.logo_url ? org.logo_url : '/assets/images/default-project-logo.png'}}" referrerpolicy="no-referrer"></a>

        </span>

        <!-- organization key -->

        <span class="project-list-row-cell">
          <span style="display: inline-block; margin-left: 12px; margin-right: 12px; ">
            <a class="project-list-row-link" style="color: black; width: 90px" routerLink="/organization/{{org.key}}">{{org.key}}</a>
          </span>
        </span>

        <!-- project's org, its name,  description -->

        <span style="max-width: 450px;" class="project-list-row-cell">

          <span style="font-size: 24px; color: black; font-weight: normal; display: block;">
            <a class="project-list-row-link" routerLink="/organization/{{org.key}}"><b>{{org.name}}</b></a>
          </span>

          <span style="font-size: 11px; font-weight: normal; color: grey;">
            <i>{{org.description}}</i>
          </span>

        </span>

        <!-- subdivisions -->

        <span class="project-list-row-cell" style="padding-left: 24px;">

         <span class="project-list-row-subdivision" *ngFor="let sub of org.subdivisions">{{sub.name}}

        </span>

      </span>
    </ul>


  </div>`
})

/**
 *
 * @class OrganizationListComponent
 *
 * render a list of the given organizations via @input
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class OrganizationListComponent implements OnInit, OnDestroy, AfterViewInit {

  /** can we edit the projects? */
  @Input() editable: boolean       = false;

  /** the set of projects being rendered */
  @Input() organizations: IOrganizationRow[] = [];


  /**
   * standard constructor
   *
   * @param router     in case we need to redirect the page
   * @param actions    the GUI actions we can invoke
   * @param route      the active URL
   * @param prjservice for working with projects
   */
  constructor(
    private router:     Router,
    private actions:    ActionService,
    private route:      ActivatedRoute,
    private prjservice: ProjectService
  ) {

  }

  /* on creation subscribe to the alert service so we get updates when alerts happen from anywhere */
  ngOnInit() {

    let pl: OrganizationListComponent = this;

    Logger.debug('[OrganizationListComponent] init...');



  }

  ngAfterViewInit() {


  }

  /* clean up at the end */
  ngOnDestroy() {

  }
}
